import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  contentItem: belongsTo('content-item'),
});
